import React from 'react';
import { Box, Heading } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import { useHasAccess } from '@/modules/core/hooks';

import EnrollmentMatrix from './EnrollmentMatrix';
import { PayoutDefinitions } from './PayoutDefinition';
import { ProcessingRules } from './ProcessingRule';
import { ServicesContainer } from './Services';

interface Props {
  isEmployer?: boolean;
}
const ProcessingDefinition: React.FC<Props> = ({ isEmployer }) => {
  const isPayoutDefinitionsAccessible = useHasAccess([
    { permission: Permissions.SET_UP_PROCESSING_DEFINITION },
    { permission: Permissions.MANAGE_PAYOUT_DEFINITION },
  ]);
  const isServicesAccessible = useHasAccess([
    { permission: Permissions.MANAGE_SERVICES },
    { permission: Permissions.SET_UP_PROCESSING_DEFINITION },
  ]);

  return (
    <Box pad={{ top: 'l' }} style={{ position: 'relative' }}>
      <Heading level={4} size="large" color="textTitle">
        Processing Definition
      </Heading>
      <EnrollmentMatrix isEmployer={isEmployer} />
      <ProcessingRules />
      {isPayoutDefinitionsAccessible && <PayoutDefinitions />}
      {isServicesAccessible && <ServicesContainer />}
    </Box>
  );
};

export default ProcessingDefinition;
